import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden" aria-label="首页主视觉">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20home%20interior%20with%20premium%20durable%20furniture%20and%20natural%20textures%2C%20soft%20diffused%20natural%20light%20streaming%20through%20large%20windows%2C%20cream%20beige%20and%20warm%20wood%20tones%2C%20peaceful%20elegant%20atmosphere%2C%20high%20quality%20artistic%20editorial%20photography%2C%20timeless%20aesthetic%2C%20spacious%20serene%20composition&width=1800&height=900&seq=hero-main-bg-01&orientation=landscape"
        alt="久久久品质生活"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/25"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-[900px] mx-auto">
        <p className="text-white/80 text-sm md:text-base font-label tracking-[0.2em] uppercase mb-3 md:mb-4 animate-[fadeInUp_0.8s_ease-out]">
          经久不衰 · 信赖之选
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4 md:mb-6 animate-[fadeInUp_0.8s_ease-out_0.1s_backwards]">
          持久稳定的品质体验
        </h1>
        <p className="text-white/75 text-sm md:text-lg max-w-[620px] mx-auto leading-relaxed mb-8 md:mb-10 animate-[fadeInUp_0.8s_ease-out_0.2s_backwards]">
          久久久代表持久、稳定与长效的极致追求。无论您寻求的是经久耐用的产品还是持续有效的服务，久久久都为您提供经得起时间检验的优质体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 animate-[fadeInUp_0.8s_ease-out_0.3s_backwards]">
          <Link
            to="/category/home-living"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-white text-foreground-950 font-medium text-sm hover:bg-white/90 transition-all duration-300 cursor-pointer"
          >
            探索产品
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            了解久久久
          </Link>
        </div>
      </div>
    </section>
  );
}